import LoadingSpinner from "../../LoadingSpinner";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Input from "../../input/Input";
import Dropdown from "../../input/Dropdown";
import Button from "../../input/Button";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import Grid from "../../Grid";
import { currencyContains, currencyName } from "../../../api/currencyApi";
import SearchDropdown from "../../input/SearchDropdown";
import {
  exchangeHeaderValidations,
  exchangeRateValidations,
} from "../../validations/ExchangeRateCreation";
import { bankContains, branchByBankAndContains } from "../../../api/bankApi";
import { AUTH_TYPES, FORMS, MODULES } from "../../../const";
import { User } from "react-feather";
import InfoList from "../../InfoList";
import { formatFromJsonDate } from "../../../dateConfig";
import useUserCompany from "../../../hooks/useUserCompany";

const FORM = FORMS.EXCHANGE_RATE.EXC_DETAIL.form;

const ExchangeRateForm = forwardRef(
  ({ errors, dropdown, isLoading, currentValues, editMode }, ref) => {
    const [bankSelected, setBankSelected] = useState(false);
    const [currentExchangeRate, setCurrentExchangeRate] = useState({});
    const [deletedList, setDeletedList] = useState([]);
    const [exchangeRateList, setExchangeRateList] = useState([]);

    const userCompany = useUserCompany();

    const [company, setCompany] = useState(
      userCompany ? userCompany.comId : null
    );

    useEffect(() => {
      setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);

    //counts
    const [excCount, setExcCount] = useState(2);
    // flags
    const [isAddLoading, setIsAddLoading] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [searchCurrenReset, setSearchCurrenReset] = useState(false);
    const [searchBaseCurrenReset, setSearchBaseCurrenReset] = useState(false);
    // errors
    const [currentErrors, setCurrentErrors] = useState({});
    //utils
    const today = new Date().toISOString().split("T")[0];

    const bankBranchRef = useRef();

    useEffect(() => {
      setCurrentErrors(errors);
    }, [errors]);

    const [exchangeRateData, setExchangeRateData] = useState({
      excCode: "",
      excReferance: "",
      excExchange: "",
      excCurrency: "",
      excRate: 0,
      excSelling: "",
      excBuying: "",
      excStatus: 2,
      excActive: 1,
      currencyName: "",
    });

    const [exchangeHeaderData, setExchangeHeaderData] = useState(
      editMode
        ? {
            ...currentValues,
            exhFrom: currentValues.exhFrom,
            exhTo: currentValues.exhTo,
            exhExchangeRates: currentValues.exhExchangeRates,
            exhCompany: company,
          }
        : {
            exhCode: "",
            exhReferance: "",
            exhFrom: "",
            exhTo: "",
            minToDate: today,
            exhBaseCurrency: "",
            exhBank: "",
            exhBranch: "",
            exhStatus: "",
            exhActive: "",
            exhExchangeRates: exchangeRateList,
            exhBase: "",
            exhCompany: company,
          }
    );

    useEffect(() => {
      (async () => {
        if (editMode) {
          const baseCurrency = await currencyName(
            currentValues.exhBaseCurrency
          );
          console.log("baseCurrency-----------");
          console.log(baseCurrency);
          let currentExchangeRates = [];
          let id = 2;
          for (let currentValue of currentValues.exhExchangeRates) {
            const currency = await currencyName(currentValue.excCurrency);
            currentExchangeRates.push({
              ...currentValue,
              exhFrom: currentValues.exhFrom,
              exhTo: currentValues.exhTo,
              excCurr: currency,
              exhBase: baseCurrency,

              id,
            });
            ++id;
          }
          setExcCount(id);
          setExchangeRateList(currentExchangeRates);
        }
        // setExchangeRateData(exchangeHeaderData.exhExchangeRates);
      })();
    }, [editMode, currentValues]);

    useEffect(() => {
      if (buttonClicked) {
        setSearchCurrenReset(true);
        setExchangeRateData({
          excCode: "",
          excReferance: "",
          excExchange: "",
          excCurrency: "",
          excRate: "",
          excSelling: "",
          excBuying: "",
          excStatus: 2,
          excActive: 1,
        });

        setButtonClicked(false);
        setCurrentExchangeRate({});
      }
    }, [buttonClicked]);

    useEffect(() => {
      setExchangeRateData({
        excCode: "",
        excReferance: "",
        excExchange: "",
        excCurrency: "",
        excRate: "",
        excSelling: "",
        excBuying: "",
        excStatus: 2,
        excActive: 1,
      });
    }, []);

    useEffect(() => {
      (async () => {
        setCurrentErrors(false);
        if (Object.keys(currentExchangeRate).length > 0) {
          const currency = await currencyName(currentExchangeRate.excCurrency);
          setExchangeRateData({
            ...currentExchangeRate,
            excCurrency: currentExchangeRate.excCurrency,
            currencyName: currency,
          });
        }
      })();
    }, [currentExchangeRate]);

    const handleFromDateChange = (e) => {
      const newFromDate = e.target.value;
      setExchangeHeaderData((prev) => ({
        ...prev,
        exhFrom: newFromDate,
        exhTo: "",
        minToDate: newFromDate,
      }));
    };
    const handleToDateChange = (e) => {
      const newToDate = e.target.value;
      setExchangeHeaderData((prev) => ({
        ...prev,
        exhTo: newToDate,
      }));
    };
    const onAddClick = async () => {
      setIsAddLoading(true);
      const baseCurrency = await currencyName(
        exchangeHeaderData.exhBaseCurrency
      );
      const currency = await currencyName(exchangeRateData.excCurrency);

      let exchangeRateError = exchangeRateValidations({
        ...exchangeRateData,
      });

      let exchangeHeaderError = exchangeHeaderValidations({
        ...exchangeHeaderData,
      });
      let combinedErrors = {
        ...exchangeRateError,
        ...exchangeHeaderError,
      };
      combinedErrors = Object.assign(
        {},
        exchangeRateError,
        exchangeHeaderError
      );

      if (
        Object.keys(exchangeRateError).length === 0 &&
        Object.keys(exchangeHeaderError).length === 0
      ) {
        if (!exchangeRateData.excId || exchangeRateData.excId === null) {
          if (!exchangeRateData.id || exchangeRateData.id === null) {
            setExchangeRateList((prevState) => [
              ...prevState,
              {
                ...exchangeRateData,
                exhFrom: exchangeHeaderData.exhFrom,
                exhTo: exchangeHeaderData.exhTo,
                exhBase: baseCurrency,
                excCurr: currency,
                exhCode: exchangeHeaderData.exhCode,
                excRate: exchangeRateData.excRate,
                id: excCount,
              },
            ]);
            setExcCount((prevState) => ++prevState);
          } else {
            setExchangeRateList((prevState) =>
              prevState.filter((item) => item.id !== exchangeRateData.id)
            );
            setExchangeRateList((prevState) => [
              ...prevState,
              {
                ...exchangeRateData,
                exhFrom: exchangeHeaderData.exhFrom,
                exhTo: exchangeHeaderData.exhTo,
                exhBase: baseCurrency,
                excCurr: currency,
                exhCode: exchangeHeaderData.exhCode,
              },
            ]);
          }
        } else {
          setExchangeRateList((prevState) =>
            prevState.filter((item) => item.excId !== exchangeRateData.excId)
          );
          setExchangeRateList((prevState) => [
            ...prevState,
            {
              ...exchangeRateData,
              exhFrom: exchangeHeaderData.exhFrom,
              exhTo: exchangeHeaderData.exhTo,
              exhBase: baseCurrency,
              excCurr: currency,
              exhCode: exchangeHeaderData.exhCode,
              modified: true,
            },
          ]);
        }
        setButtonClicked(true);
        setIsAddLoading(false);
      }
      setCurrentErrors(combinedErrors);
      setIsAddLoading(false);
    };

    const getUpdateState = () => {
      const updateState = {
        modified: [],
        unmodified: [],
        created: [],
        deleted: deletedList,
      };
      exchangeRateList.forEach((exc) => {
        if (exc.excId && exc.excId !== null) {
          if (exc.modified) {
            updateState.modified.push(exc);
          } else {
            updateState.unmodified.push(exc);
          }
        } else {
          updateState.created.push(exc);
        }
      });
      return updateState;
    };

    useImperativeHandle(ref, () => ({
      getData: () => {
        if (editMode) {
          return getUpdateState();
        } else {
          return exchangeRateList;
        }
      },
      getHeaderData: () => ({
        ...exchangeHeaderData,
        exhExchangeRates: exchangeRateList,
      }),
      resetForm: () => {
        setExchangeHeaderData({
          exhCode: "",
          exhReferance: "",
          exhFrom: "",
          exhTo: "",
          minToDate: "",
          exhBaseCurrency: "",
          exhBank: "",
          exhBranch: "",
          exhStatus: "",
          exhActive: "",
          exhBase: "",
        });
        setExchangeRateList([]);
        setSearchBaseCurrenReset(true);
        setCurrentErrors({});
      },
    }));

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Group</h4>
              <div className="two fields">
                <Input
                  module={MODULES.Finance}
                  form={FORM}
                  editMode={editMode}
                  field="exh_code"
                  label="Exchange Rate code"
                  error={currentErrors.exhCode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { exhCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="employeeCode"
                  value={exchangeHeaderData.exhCode}
                  onChange={(e) => {
                    setExchangeHeaderData((prevState) => ({
                      ...prevState,
                      exhCode: e.target.value,
                    }));
                  }}
                  disabled={true}
                />
              </div>
              <div className="two fields">
                <Input
                  module={MODULES.Finance}
                  form={FORM}
                  editMode={editMode}
                  field="exh_from"
                  label="From"
                  required={true}
                  error={currentErrors.exhFrom}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { exhFrom: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="fromDate"
                  placeholder="From"
                  value={exchangeHeaderData.exhFrom}
                  min={exchangeHeaderData.minToDate}
                  onChange={handleFromDateChange}
                />
                <Input
                  required={true}
                  module={MODULES.Finance}
                  form={FORM}
                  editMode={editMode}
                  field="exh_to"
                  label="To"
                  error={currentErrors.exhTo}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { exhTo: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="toDate"
                  placeholder="To"
                  value={exchangeHeaderData.exhTo}
                  min={exchangeHeaderData.minToDate} // Set the minimum date for the "To" date input
                  onChange={handleToDateChange}
                />
                {/*<Dropdown*/}
                {/*    required={true}*/}
                {/*    label="Base Currency"*/}
                {/*    error={currentErrors.exhBaseCurrency}*/}
                {/*    resetError={() =>*/}
                {/*        setCurrentErrors((prevState) => {*/}
                {/*            const {exhBaseCurrency: _, ...rest} = prevState;*/}
                {/*            return rest;*/}
                {/*        })*/}
                {/*    }*/}
                {/*    placeholder="Base Currency"*/}
                {/*    // options={dropdown.statusOptions}*/}
                {/*    value={exchangeHeaderData.exhBaseCurrency}*/}
                {/*    style={{height: "20px"}}*/}
                {/*    onChange={(e, data) => {*/}
                {/*        setExchangeHeaderData((prevState) => ({*/}
                {/*            ...prevState,*/}
                {/*            exhBaseCurrency: data.value,*/}
                {/*        }));*/}
                {/*    }}*/}
                {/*/>*/}

                <SearchDropdown
                  required={true}
                  module={MODULES.Finance}
                  form={FORM}
                  field="exh_base_currency"
                  placeholder={"base currency"}
                  editMode={editMode}
                  reset={searchBaseCurrenReset}
                  setReset={setSearchBaseCurrenReset}
                  clearable={true}
                  onResultSelect={(data) =>
                    setExchangeHeaderData((prevState) => ({
                      ...prevState,
                      exhBaseCurrency: data,
                    }))
                  }
                  api={currencyContains}
                  fieldInfo={{
                    tableName: "masterdata.tms_vm_reg_currency",
                    primaryKey: "cur_id",
                    fieldName: "cur_currency",
                    id: exchangeHeaderData.exhBaseCurrency,
                  }}
                  label="Base Currency"
                  error={currentErrors.exhBaseCurrency}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { exhBaseCurrency: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  key={2}
                  editMode={editMode}
                  reset={searchBaseCurrenReset}
                  setReset={setSearchBaseCurrenReset}
                  clearable={true}
                  onClear={() => {
                    setExchangeHeaderData((prevState) => ({
                      ...prevState,
                      exhBank: null,
                      exhBranch: null,
                    }));
                    setBankSelected(false);
                    bankBranchRef.current.reset();
                  }}
                  onResultSelect={(data) => {
                    setExchangeHeaderData((prevState) => ({
                      ...prevState,
                      exhBank: data,
                      exhBranch: null,
                    }));

                    setBankSelected(true);
                    bankBranchRef.current.reset();
                  }}
                  api={bankContains}
                  fieldInfo={{
                    tableName: "masterdata.tms_vm_banks",
                    primaryKey: "bnk_id",
                    fieldName: "bnk_name",
                    id: exchangeHeaderData.exhBank,
                  }}
                  module={MODULES.Finance}
                  form={FORM}
                  field="exh_bank"
                  label="Bank"
                  error={currentErrors.exhBank}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { exhBank: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
                <SearchDropdown
                  key={3}
                  ref={bankBranchRef}
                  editMode={editMode}
                  reset={searchBaseCurrenReset}
                  setReset={setSearchBaseCurrenReset}
                  clearable={true}
                  onClear={() => {
                    setExchangeHeaderData((prevState) => ({
                      ...prevState,
                      exhBranch: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setExchangeHeaderData((prevState) => ({
                      ...prevState,
                      exhBranch: data,
                    }))
                  }
                  api={branchByBankAndContains}
                  apiDependency={{ bank: exchangeHeaderData.exhBank }}
                  fieldInfo={{
                    tableName: "masterdata.tms_vm_bank_branches",
                    primaryKey: "brn_id",
                    fieldName: "brn_name",
                    id: exchangeHeaderData.exhBranch,
                  }}
                  disabled={!bankSelected}
                  module={MODULES.Finance}
                  form={FORM}
                  field="exh_branch"
                  label="Branch"
                  error={currentErrors.exhBranch}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { exhBranch: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>
            </div>
            <div className="ui segment">
              <div className="three fields">
                {/*<Dropdown*/}
                {/*    required={true}*/}
                {/*    label="Currency"*/}
                {/*    error={currentErrors.excCurrency}*/}
                {/*    resetError={() =>*/}
                {/*        setCurrentErrors((prevState) => {*/}
                {/*            const {excCurrency: _, ...rest} = prevState;*/}
                {/*            return rest;*/}
                {/*        })*/}
                {/*    }*/}
                {/*    placeholder="Currency"*/}
                {/*    // options={dropdown.statusOptions}*/}
                {/*    value={exchangeRateData.excCurrency}*/}
                {/*    style={{height: "20px"}}*/}
                {/*    onChange={(e, data) => {*/}
                {/*        setExchangeRateData((prevState) => ({*/}
                {/*            ...prevState,*/}
                {/*            excCurrency: data.value,*/}
                {/*        }));*/}
                {/*    }}*/}
                {/*/>*/}

                <SearchDropdown
                  key={10}
                  readOnly={!exchangeHeaderData.exhBaseCurrency}
                  required={true}
                  multiGrid={true}
                  multiGridCurrentValue={exchangeRateData.currencyName}
                  placeholder={"currency"}
                  editMode={editMode}
                  clearable={true}
                  reset={searchCurrenReset}
                  setReset={setSearchCurrenReset}
                  onResultSelect={(data) =>
                    setExchangeRateData((prevState) => ({
                      ...prevState,
                      excCurrency: data,
                    }))
                  }
                  api={async (search) => {
                    const results = await currencyContains(search);
                    return results.filter(
                      (item) =>
                        item.value !== exchangeHeaderData.exhBaseCurrency
                    );
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_vm_reg_currency",
                    primaryKey: "cur_id",
                    fieldName: "cur_currency",
                    id: exchangeRateData.excCurrency,
                  }}
                  module={MODULES.Finance}
                  form={FORM}
                  field="exc_currency"
                  label="Currency"
                  error={currentErrors.excCurrency}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { excCurrency: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />

                <Input
                  type="number"
                  step="0.0001"
                  module={MODULES.Finance}
                  form={FORM}
                  editMode={editMode}
                  field="exc_rate"
                  label="Rate"
                  required={true}
                  error={currentErrors.excRate}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { excRate: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Rate"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  value={exchangeRateData.excRate}
                  onChange={(e) => {
                    setExchangeRateData((prevState) => ({
                      ...prevState,
                      excRate: parseFloat(e.target.value),
                    }));
                  }}
                />
                <Input
                  type="number"
                  step="0.0001"
                  module={MODULES.Finance}
                  form={FORM}
                  editMode={editMode}
                  field="exc_buying"
                  label="Buying"
                  error={currentErrors.excBuying}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { excBuying: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Buying"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  value={exchangeRateData.excBuying}
                  onChange={(e) => {
                    setExchangeRateData((prevState) => ({
                      ...prevState,
                      excBuying: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="three fields">
                <Input
                  type="number"
                  step="0.0001"
                  module={MODULES.Finance}
                  form={FORM}
                  editMode={editMode}
                  field="exc_selling"
                  label="Selling"
                  error={currentErrors.excSelling}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { excSelling: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Selling"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  value={exchangeRateData.excSelling}
                  onChange={(e) => {
                    setExchangeRateData((prevState) => ({
                      ...prevState,
                      excSelling: e.target.value,
                    }));
                  }}
                />
                <Dropdown
                  module={MODULES.Finance}
                  form={FORM}
                  editMode={editMode}
                  field="exc_status"
                  label="Status"
                  error={currentErrors.excStatus}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { excStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={dropdown.statusOptions}
                  value={exchangeRateData.excStatus}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setExchangeRateData((prevState) => ({
                      ...prevState,
                      excStatus: data.value,
                    }));
                  }}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              <Button
                template="reset"
                onClick={(e) => {
                  setButtonClicked(true);
                }}
              />
              <Button
                template="addOrSave"
                authenticated={true}
                editMode={editMode}
                module={MODULES.Finance}
                form={`${FORM}`}
                create={Object.keys(currentExchangeRate).length === 0}
                onClick={onAddClick}
                isLoading={isAddLoading}
              />
            </div>
            <small style={{ color: "#9f3a38" }}>{`${
              currentErrors.mainCountError ? currentErrors.mainCountError : ""
            }`}</small>
            <Grid
              heading="Exchange Rate List"
              config={[
                // { headerName: "Code", field: "excCode" },
                { headerName: "Base Currency", field: "exhBase" },
                { headerName: "Currency", field: "excCurr" },
                { headerName: "Rate", field: "excRate" },
                { headerName: "From", field: "exhFrom" },
                { headerName: "To", field: "exhTo" },
                {
                  field: "Edit",
                  filter: true,
                  cellRenderer: ButtonRenderer,
                  cellRendererParams: (params) => ({
                    consider: AUTH_TYPES.CREATE,
                    clickHandler: () => {
                      setCurrentExchangeRate(params.data);
                    },
                    label: "Edit",
                    authenticated: true,
                    form: `${FORM}`,
                    module: MODULES.Finance,
                    editMode: editMode,
                  }),
                },
                {
                  field: "Delete",
                  filter: true,
                  cellRenderer: ButtonRenderer,
                  cellRendererParams: (params) => ({
                    consider: AUTH_TYPES.CREATE,
                    clickHandler: () => {
                      if (params.data.excId && params.data.excId !== null) {
                        setDeletedList((prevState) => [
                          ...prevState,
                          params.data.excId,
                        ]);
                      }
                      setExchangeRateList((prevAlerts) =>
                        prevAlerts.filter(
                          (exchangeList) => exchangeList.id !== params.data.id
                        )
                      );
                    },
                    label: "Delete",
                    className: "ui red button",
                    authenticated: true,
                    form: `${FORM}`,
                    module: MODULES.Finance,
                    editMode: editMode,
                  }),
                },
              ]}
              content={exchangeRateList}
            />
            {editMode && (
              <InfoList
                title="User Information"
                content={[
                  {
                    title: "Created By",
                    value: exchangeHeaderData.createdBy
                      ? exchangeHeaderData.createdBy
                      : "N/A",
                  },
                  {
                    title: "Created Date",
                    value: exchangeHeaderData.createdDate
                      ? formatFromJsonDate(exchangeHeaderData.createdDate)
                      : "N/A",
                  },
                  {
                    title: "Last Modified By",
                    value: exchangeHeaderData.lastModifiedBy
                      ? exchangeHeaderData.lastModifiedBy
                      : "N/A",
                  },
                  {
                    title: "Last Modified Date",
                    value: exchangeHeaderData.lastModifiedDate
                      ? formatFromJsonDate(exchangeHeaderData.lastModifiedDate)
                      : "N/A",
                  },
                ]}
                Icon={User}
              />
            )}
          </form>
        )}
        ;
      </>
    );
  }
);

export default ExchangeRateForm;
